import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MerchantListSearchRequest } from "../api-interfaces";
import { DEFAULT_PAGE_SIZE, TableConfig } from "../../configs/constants";

interface MerchantList {
  searchCriteria: MerchantListSearchRequest;
  tableConfig: TableConfig;
}

export const INITIAL_SEARCH_CRITERIA: MerchantListSearchRequest = {
  serviceCode: "",
  contractType: "",
  contractRoute: "",
  companyName: "",
  ipid: "",
  siteId: "",
  merchantManagementNumber: "",
  merchantName: "",
  storeName: "",
  shopCode: "",
  businessCode: "",
  excludeCancelledFlag: true,
  corporateNumber: "",
  dunsNo: "",
  gwCompanyNo: "",
  merchantTypeNo: "",
  qrPresentationCategory: "",
  industryCode: "",
  shopId: "",
  creditCardOrderTarget: "",
  creditCardMerchantNumber: "",
  settlementGroupId: "",
  accessKey: "",
  companyCode: "",
  timestamp: -1,
  registeredCompanyCorpNo: "",
  registeredCompanyCompanyName: "",
} as const;

const initialState: MerchantList = {
  searchCriteria: INITIAL_SEARCH_CRITERIA,
  tableConfig: {
    pageSize: DEFAULT_PAGE_SIZE,
    pageIndex: 1,
    columnWidths: [],
  },
};

const merchantListSlice = createSlice({
  name: "merchantList",
  initialState,
  reducers: {
    setSearchCriteria: (
      state,
      action: PayloadAction<MerchantListSearchRequest>
    ) => {
      state.searchCriteria = action.payload;
      state.tableConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: 1,
        columnWidths: [],
      };
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageIndex = action.payload;
    },
    setColumnWidths: (state, action: PayloadAction<number[]>) => {
      state.tableConfig.columnWidths = action.payload;
    },
    changePageSize: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageSize = action.payload;
      state.tableConfig.pageIndex = 1;
    },
  },
});

export const {
  setSearchCriteria,
  setPageIndex,
  setColumnWidths,
  changePageSize,
} = merchantListSlice.actions;

export default merchantListSlice.reducer;
